<template>
  <el-card>
    <div v-wechat-title="title" />

    <template #header>
      <content-header />
    </template>
    <el-row type="flex" justify="left">
      <lz-form ref="form" :get-data="getData" :submit="onSubmit" :form.sync="form" :errors.sync="errors" :edit-mode="editMode">
        <el-tabs v-model="activeName" @tab-click="handleClick" justify="center">
          <el-tab-pane label="商品信息" name="first">
            <el-form-item label="商品标题" required prop="name"><el-input v-model="form.name"/></el-form-item>
            <el-form-item label="是否上架" required prop="marketable">
              <el-switch v-model="form.marketable" active-text="上架" inactive-text="下架" />
            </el-form-item>
            <el-form-item label="商品分类" required prop="goods_category">
              <el-select v-model="goodsCategoryInfo.name" placeholder="请选择商品分类" ref="selectGoodsCategory">
                <el-option
                  :value="goodsCategoryInfo.code"
                  :label="goodsCategoryInfo.name"
                  style="height:200px;overflow: auto;background-color:#fff"
                >
                  <el-tree :data="goodsCategory" :props="defaultProps" @node-click="handleNodeClick" />
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品类型" required prop="goods_type">
              <el-select v-model="form.goods_type" filterable clearable>
                <el-option v-for="i of goodsTypeOptions" :key="i.id" :label="i.name" :value="i.id">
                  <span>{{ i.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="销售类型" required prop="sales_type">
              <el-select v-model="form.sales_type" filterable clearable>
                <el-option v-for="i of salesTypeOptions" :key="i.id" :label="i.name" :value="i.id">
                  <span>{{ i.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运费模板" required prop="freight_template_id">
              <el-select v-model="form.freight_template_id" placeholder="请选择" filterable clearable>
                <el-option v-for="item in freightTemplatesOptions" :key="item.index" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="商品图片" required prop="pic"><file-picker v-model="form.pic" ext="jpg,gif,png,jpeg"/></el-form-item>
            <el-form-item label="零售价格" required prop="price"><el-input v-model="form.price"/></el-form-item>
            <el-form-item label="基金分红" prop="fund_bonus"><el-input v-model="form.fund_bonus"/></el-form-item>
            <el-form-item label="盛塘基金" prop="stagent_fund"><el-input v-model="form.stagent_fund"/></el-form-item>
            <el-form-item label="发货中心奖" prop="delivery_rebate"><el-input v-model="form.delivery_rebate"/></el-form-item>
            <el-form-item label="商品关联云仓的id" required prop="sku_id"><el-input v-model="form.sku_id"/></el-form-item>
            <el-form-item label="商品简介" prop="brief">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6 }" v-model="form.brief" />
            </el-form-item>
            <el-form-item label="商品介绍" prop="brief">
              <tinymce
                ref="intro"
                v-model="form.intro"
                :height="400"
                :toolbar="[
                  'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
                  'hr bullist numlist link charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
                ]"
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="代理价格配置" name="third">
            <el-form-item label="" prop="level_json">
              <el-row :gutter="5">
                <el-col :span="5"><strong>拿货价</strong></el-col>
                <el-col :span="5"><strong>奖励积分</strong></el-col>
                <el-col :span="5">
                  <strong>
                    复销奖：
                    <br />
                    上一代同级返利
                  </strong>
                </el-col>
                <el-col :span="5">
                  <strong>
                    复销奖：
                    <br />
                    上二代同级返利
                  </strong>
                </el-col>
              </el-row>
            </el-form-item>
            <template v-for="item in form.level_json">
              <el-form-item :label="item.name" :key="item.index">
                <el-row :gutter="5">
                  <el-col :span="5"><el-input v-model="item.price"/></el-col>
                  <el-col :span="5"><el-input v-model="item.integral"/></el-col>
                  <el-col :span="5"><el-input v-model="item.firstRebate"/></el-col>
                  <el-col :span="5"><el-input v-model="item.secondRebate"/></el-col>
                </el-row>
              </el-form-item>
            </template>
          </el-tab-pane>
        </el-tabs>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { getFreightTemplatesByCustomerId } from '@/api/freight-templates'
import { createGood, editGood, storeGood, updateGood } from '@/api/goods'
import FilePicker from '@c/FilePicker'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'
import Tinymce from '@c/Tinymce'

export default {
  name: 'Form',
  components: {
    FilePicker,
    LzForm,
    Tinymce,
  },
  mixins: [FormHelper],
  data() {
    return {
      title: '编辑商品',
      activeName: 'first',
      form: {
        name: '',
        brief: '',
        intro: '',
        marketable: 0,
        goods_type: '',
        goods_category: '',
        sales_type: 1,
        price: 0.0,
        fund_bonus: 0,
        stagent_fund: 0,
        delivery_rebate: 0,
        freight_template_id: '',
        pic: '',
        sku_id: '',
        level_json: [],
      },
      defaultProps: {
        children: 'children',
        label: 'title',
        value: 'code',
      },
      goodsCategoryInfo: {
        code: 0,
        name: '',
      },
      freightTemplatesOptions: [],
      goodsTypeOptions: [
        { id: 0, name: '普通商品' },
        { id: 1, name: '报单商品' },
        { id: 2, name: '积分商品' },
      ],
      salesTypeOptions: [
        { id: 1, name: '线上平台' },
        { id: 2, name: '线下平台' },
        { id: 3, name: '所有平台' },
      ],
      errors: {},
      goodsCategory: [],
    }
  },
  created() {
    this.getFreightTemplatesByCustomerId()
  },
  methods: {
    handleNodeClick: function(node) {
      console.log(node, node.children, 'node')
      if (node.children.length > 0) {
      } else {
        this.goodsCategoryInfo.code = node.code
        this.goodsCategoryInfo.name = node.title
        this.form.goods_category = node.code
        // this.$refs.selectGoodsCategory.blur()
        console.log(this.goodsCategoryInfo.name, 'this.goodsCategoryInfo.name')
      }
    },
    async getFreightTemplatesByCustomerId() {
      const { data } = await getFreightTemplatesByCustomerId()
      this.freightTemplatesOptions = data
    },
    async getData() {
      if (this.editMode) {
        const {
          data: { goodInfo, goodsCategory },
        } = await editGood(this.resourceId)
        this.fillForm(goodInfo)
        this.goodsCategory = goodsCategory

        if (goodInfo.category) {
          this.goodsCategoryInfo.code = goodInfo.category.code || ''
          this.goodsCategoryInfo.name = goodInfo.category.title || ''
          this.form.goods_category = goodInfo.category.code || ''
        }

        this.title = '编辑商品[' + goodInfo.name + ']'
        this.$route.meta.title = this.title
        this.$store.dispatch('tagsView/updateVisitedView', this.$route)
      } else {
        const {
          data: { goodInfo, goodsCategory },
        } = await createGood()
        this.form.level_json = goodInfo.level_json
        this.goodsCategory = goodsCategory
      }
    },
    async onSubmit() {
      if (this.editMode) {
        await updateGood(this.resourceId, this.form)
      } else {
        await storeGood(this.form)
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.intro.setContent('')
    next()
  },
}
</script>

<style scoped lang="scss">
.editor-content {
  margin-top: 20px;
}
</style>
